import React, { useEffect, useState } from 'react';
import { StyledTab, StyledTabs, Wrapper } from './StylovyzeTabs.styles';
const TabPanel = ({ children, value, index, baseId, ...other }) => {
    return (React.createElement("div", { className: "tabpanel", role: "tabpanel", hidden: value !== index, id: `${baseId}-tabpanel-${index}`, "aria-labelledby": `${baseId}-tab-${index}`, ...other }, value === index && React.createElement(React.Fragment, null, children)));
};
/**
 * Styled tab component
 */
export const StylovyzeTabs = ({ tabs, baseId, dataCy, className, TabsProps, }) => {
    // get the first tab that isn't disabled
    const startValue = tabs.findIndex(({ disabled }) => !disabled);
    const [value, setValue] = useState(startValue);
    useEffect(() => {
        setValue(tabs.findIndex(({ disabled }) => !disabled));
    }, [tabs]);
    return (React.createElement(Wrapper, { className: className, "data-cy": dataCy },
        React.createElement(StyledTabs, { ...TabsProps, value: value, onChange: (_, newValue) => setValue(newValue) }, tabs.map(({ title, disabled, cy }, i) => (React.createElement(StyledTab, { key: i, label: title, id: `${baseId}-tab-${i}`, "aria-controls": `${baseId}-tabpanel-${i}`, disabled: disabled, "data-cy": cy })))),
        tabs.map(({ content }, i) => (React.createElement(TabPanel, { key: i, value: value, index: i, baseId: baseId }, content)))));
};
StylovyzeTabs.defaultProps = {};
export default React.memo(StylovyzeTabs);
